import { Callout, DefaultButton, IconButton, IIconProps, Persona, PersonaPresence, PersonaSize, PrimaryButton, TooltipHost } from '@fluentui/react';
import { Button, Dialog as DialogNorth, Flex, FlexItem, Label } from '@fluentui/react-northstar';
import * as microsoftTeams from "@microsoft/teams-js";
import { useBoolean, useId } from '@uifabric/react-hooks';
import { Dialog, DialogFooter, DialogType, IDialogContentProps, IDialogStyles } from 'office-ui-fabric-react/lib/Dialog';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import * as React from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import hubService from '../../api/services/hub';
import { CalendarInline } from '../../components/Calendar/index';
import HubShareDialog from '../../components/HubShare/dialog';
import Loader from '../../components/Loader';
import MeetingCard from '../../components/MeetingCard';
import MyMeetingFileItem from '../../components/MyMeetingFileItem';
import { HubFile } from '../../model';
import { Attendee, TeamEventCard } from '../../model/api/graph';
import defaultImage from '../../static/media/nocontent.png';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import { addAppToMeeting, addToMeeting, getMeetingsContents, getTeamEvents, removeContent, saveMeeting, updateMessage, updateRemoveFile } from '../../store/Meeting/actions';
import { getPopularStories } from '../../store/Popular/actions';
import SearchContent from '../Search';
import SearchContentInMeeting from '../SearchInMeeting';
//import ShareTabbedView from '../ShareTabbedView';
import styles from './index.module.scss';

const MyMeetings = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const {
        teamEvents,
        selectedDate,
        currentMeeting,
        theme,
        selectedFilesForRemove
    } = useTypedSelector((state: ApplicationState) => state.meeting);

    const addIcon: IIconProps = { iconName: 'Add' };
    const leftIcon: IIconProps = { iconName: 'ChevronLeft' };
    const rightIcon: IIconProps = { iconName: 'ChevronRight' };
    const calendarIcon: IIconProps = { iconName: 'Calendar' };
    const joinIcon: IIconProps = {
        iconName: 'JoinOnlineMeeting',
        styles: {
            root: { fontSize: '24px', color: '#f26724' }
        }
    };

    const editIcon: IIconProps = {
        iconName: 'Edit',
        styles: {
            root: { fontSize: '24px', color: '#f26724' }
        }
    };

    const shareIcon: IIconProps = {
        iconName: 'Share',
        styles: {
            root: { fontSize: '24px', color: '#f26724' }
        }
    };

    const deleteIcon: IIconProps = {
        iconName: 'Delete',
        styles: {
            root: { fontSize: '24px', color: '#f26724' }
        }
    };

    const fileIcon: IIconProps = {
        iconName: 'OpenFile',
        styles: {
            root: { fontSize: '24px', color: '#f26724' }
        }
    };

    const todayDate: Date = new Date();

    window.addEventListener('resize', handleResize);

    React.useEffect(() => {
        dispatch(getPopularStories());
    }, []);

    React.useEffect(() => {
        if (currentMeeting && currentMeeting.meetingContents && currentMeeting.meetingContents.length > 0) {
            setLoader(false);
        }
        else {
            setLoader(true);
        }
    }, [currentMeeting]);

    React.useEffect(() => {
        setEventLoader(false);
    }, [teamEvents]);

    const changeToLocalTimezone = (inputDate: Date) => {
        let returnDate = new Date(inputDate);
        let offset = new Date().getTimezoneOffset();
        returnDate.setMinutes(returnDate.getMinutes() - offset);
        return returnDate;
    }

    const onJoinClick = () => {
        let joinurl = (teamEventCard != null && teamEventCard.onlineMeeting != null) ? teamEventCard.onlineMeeting.joinUrl : "";
        microsoftTeams.executeDeepLink(joinurl);
    }

    const onCalendarClick = () => {
        microsoftTeams.executeDeepLink("https://teams.microsoft.com/l/meeting/new?startTime=" + navDay.toLocaleString());
    }

    const signOut = () => {
        localStorage.clear();
        localStorage.setItem("forceLogout", "true");
        history.push("/login");
    }

    const [selectedCard, setSelectedCard] = React.useState("");
    const [navDay, setNavDay] = React.useState<Date>(todayDate);
    const [startTime, setStartTime] = React.useState("");
    const [subject, setSubject] = React.useState("");
    const [chatId, setChatId] = React.useState("");
    const [teamEventCard, setEvent] = React.useState({} as TeamEventCard);
    const [isLoder, setLoader] = React.useState(false);
    const [isEventLoder, setEventLoader] = React.useState(false);
    const [isAppAdded, setAppAdded] = React.useState(false);
    const [openAddContent, setOpenAddContent] = React.useState(false);
    const [selectedSearchFiles, updateSelectedSearchFile] = React.useState([] as {
        fileId: number;
        storyId: number;
    }[]);
    const [calloutExtraName, setCalloutExtraName] = React.useState<string[]>([]);
    const [showCalCallout, { setTrue: openCal, setFalse: hideCal }] = useBoolean(false);
    const [width, setWidth] = React.useState(window.innerWidth);
    const [isMobile, setMobile] = React.useState(false);
    const [isMeetingClicked, setMeetingClicked] = React.useState(false);

    //Tabbed view is disabled for now
    // const [isTabbedView, setTabbedView] = React.useState(false);
    //React.useEffect(() => { 
    //        if (localStorage.getItem("PresentContentInvoke") == "Y") {
    //            localStorage.setItem("PresentContentInvoke", "N");
    //            openContent();
    //        }        
    //}, []);

    function handleResize() {
        setWidth(window.innerWidth)
    }

    React.useEffect(() => {
        window.addEventListener('resize', handleResize)
        if (window.innerWidth <= 767) {
            setMobile(true);
            setMeetingClicked(false);
        }
        else {
            setMobile(false);
        }
    }, [window.innerWidth]);

    React.useEffect(() => {
        if (chatId != null && chatId !== "") {
            setMeetingClicked(true);
        }
        else {
            setMeetingClicked(false);
        }
    }, [chatId]);

    React.useEffect(() => {
        if (width <= 767) {
            setMobile(true);
        }
        else {
            setMobile(false);
        }
    }, [width]);

    const onHoverExtra = (e: any, remaining: Attendee[]) => {
        let newRem = remaining.slice(7, remaining.length);
        let name: string[] = [];
        newRem.forEach((atten) => { name.push(atten.emailAddress.name) });
        setCalloutExtraName(name)
    }

    const onFileItemDelete = () => {
        let updatedEvent = teamEventCard;
        updatedEvent.fileCount = updatedEvent.fileCount - 1;
        setEvent(updatedEvent);
    }

    const addSelectedFileToMeeting = () => {
        setLoader(true);
        if (!teamEventCard.isAppAdded) {
            microsoftTeams.initialize(() => {
                hubService.getLoggedInUser().then((profile) => {
                    microsoftTeams.getContext((context) => {
                        if (chatId) {
                            const userProfile: any = profile;
                            const userId = userProfile.value.id;
                            const userEmail = userProfile.value.email;
                            const data = {
                                meetingId: chatId,
                                eventId: (teamEventCard != null) ? teamEventCard.id : "",
                                description: '',
                                name: '',
                                hubUserId: userId,
                                hubEmail: userEmail,
                                userEmail: context.loginHint,
                                contents: [],
                                attendee: [{
                                    email: context.loginHint,
                                    name: context.userPrincipalName
                                }]
                            };
                            setAppAdded(true);
                            Promise.resolve(dispatch(saveMeeting(data))).then(() => {
                                dispatch(addAppToMeeting(chatId));
                                selectedSearchFiles.forEach((item) => {
                                    dispatch(addToMeeting(chatId, item.fileId, item.storyId, ''));
                                });

                                let updatedEvent = teamEventCard;
                                updatedEvent.chatId = chatId;
                                updatedEvent.isAppAdded = true;
                                updatedEvent.fileCount = selectedSearchFiles.length;
                                setEvent(updatedEvent);
                            });
                        }

                    });
                });
            });
        }
        else {
            selectedSearchFiles.forEach((item) => {
                dispatch(addToMeeting(chatId, item.fileId, item.storyId, ''));
            });
            let updatedEvent = teamEventCard;
            updatedEvent.fileCount = teamEventCard.fileCount + selectedSearchFiles.length;
            setEvent(updatedEvent);
        }
        setOpenAddContent(false);
    };

    const onEditClick = () => {
        let eventId = (teamEventCard != null) ? teamEventCard.id : "";
        let deeplink = "https://teams.microsoft.com/_#/scheduling-form/?eventId=" + eventId + "&conversationId=" + chatId + "&opener=1&providerType=0&navCtx=event-card-click&calendarType=User";
        microsoftTeams.executeDeepLink(deeplink);
    }

    const onMeetingClick = (teamEventCard: TeamEventCard) => {
        //reset meeting contents
        if (currentMeeting && currentMeeting.meetingContents && currentMeeting.meetingContents.length > 0) {
            currentMeeting.meetingContents = [];
        }
        setSelectedCard(teamEventCard.id);
        setMeetingClicked(true);
        if (teamEventCard != null) {
            setChatId("");
            teamEventCard.isSelected = true;
            setEvent(teamEventCard);
            let joinUri = decodeURIComponent(teamEventCard.onlineMeeting.joinUrl);
            let startDateTime = new Date(teamEventCard.start.dateTime);
            let a: string = new Date(changeToLocalTimezone(startDateTime)).toDateString() + " at " + getLocalTime(teamEventCard.start.dateTime);
            setStartTime(a);
            setSubject(teamEventCard.subject);
            if (!teamEventCard.isAppAdded) {
                setAppAdded(false);
                let split = joinUri.split("/");
                split.forEach((item) => {
                    if (item.includes("meeting") && item.includes("@")) {
                        dispatch(getMeetingsContents(item));
                        setChatId(item);
                        return;
                    }
                });
            }
            else {
                setAppAdded(true);
                setChatId(teamEventCard.chatId);
                dispatch(getMeetingsContents(teamEventCard.chatId));
            }
        }
    };

    const getLocalTime = (inputDate: Date) => {
        let localDateTime = new Date(changeToLocalTimezone(inputDate));
        var hours = localDateTime.getHours();
        var minutes: any = localDateTime.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    const selectedDateChanged = (selectedDate: Date) => {
        setNavDay(selectedDate);
        commonLogic(selectedDate);
        hideCal();
    }

    const decreaseDate = () => {
        navDay.setDate(navDay.getDate() - 1)
        setNavDay(navDay);
        commonLogic(navDay);
    }

    const increaseDate = () => {
        navDay.setDate(navDay.getDate() + 1)
        setNavDay(navDay);
        commonLogic(navDay);
    }

    const goToToday = () => {
        setNavDay(todayDate);
        commonLogic(todayDate);
    }

    const getMeetingDuration = (startDateTime: Date, endDateTime: Date) => {

        let meetingDuration = " - ";
        let diff = new Date(endDateTime).getTime() - new Date(startDateTime).getTime();
        diff = diff / (1000 * 60);
        if (diff < 60) {
            meetingDuration = meetingDuration + diff + " mins"
        }
        else {
            let hr = Math.floor(diff / 60);
            meetingDuration = meetingDuration + hr + " hr";
            let mins = Math.floor(diff % 60);
            if (mins > 0) { meetingDuration = meetingDuration + " " + mins + " mins" };
        }
        return meetingDuration;
    }

    const commonLogic = (selectedDate: Date) => {
        setOpenAddContent(false);
        setEventLoader(true);
        setChatId("");
        setEvent({} as TeamEventCard);
        dispatch(getTeamEvents(selectedDate));
    }

    const extractInitials = (inputName: string) => {
        let name = inputName.split(' ');
        let initials = name[0][0];
        if (name.length > 1) {
            initials = initials + name[1][0];
        }
        else {
            if (name[0].length > 2) {
                initials = initials + name[0][1];
            }
        }
        initials = initials.toUpperCase();
        return initials;
    }

    const [selectedFileIds, updateSelectedFileIds] = React.useState([] as {
        fileId: number,
        file: HubFile,
        hubShareUrl: string
    }[]);

    const onItemCheckedChanged = (fileId: number, file: HubFile, hubShareUrl: string, checked: boolean) => {
        if (!checked) {
            const tmpIds = selectedFileIds.filter(c => c.fileId !== fileId);
            updateSelectedFileIds(tmpIds);
        }
        else {
            const tmpIds = [...selectedFileIds, {
                fileId,
                file,
                hubShareUrl
            }];
            updateSelectedFileIds(tmpIds);
        }
    }
    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
    const [hideDelete, { toggle: toggleHideDelete }] = useBoolean(false);
    const labelId: string = useId('dialogLabel');
    const subTextId: string = useId('subTextLabel');

    const onRemoveFile = () => {
        selectedFileIds.forEach((id) => { dispatch(updateRemoveFile(id.fileId as number, 'add')); })
        dispatch(removeContent(selectedFilesForRemove, currentMeeting.id));
        updateSelectedFileIds([]);
        onFileItemDelete();
        toggleHideDialog();
    }

    const onCancelClick = () => {
        if (hideDelete) {
            toggleHideDelete();
        }
        if (!hideDialog) {
            toggleHideDialog();
        }
    }

    const modalPropsStyles = {
        main: { color: theme === "default" ? 'Red' : '#FFFFFF' }, header: { color: theme === "default" ? 'Red' : '#FFFFFF' }
    };

    const modalProps = React.useMemo(
        () => ({
            titleAriaId: labelId,
            subtitleAriaId: subTextId,
            isBlocking: true,
            isModeless: false,
            isDarkOverlay: true,
            styles: modalPropsStyles,
            className: '.ms-Dialog-title'
        }),
        [labelId, subTextId],
    );


    const dialogContentProps: IDialogContentProps = {
        showCloseButton: false,
        type: DialogType.normal,
        title: 'Remove File',
        styles: {
            subText: { color: theme === "default" ? '#000000' : '#F2F2F2' }
        },
        titleProps: {
            style: { color: theme === "default" ? '#000000' : '#FFFFFF' }
        },
        subText: 'This will remove the selected file from your presentation.',
    };

    const dialogStyles: IDialogStyles = {
        root: [{

        }],
        main: [{
            selectors: {
                ['@media (min-width: 260px)']: {
                    maxWidth: '260px',
                    minWidth: '260px',
                    background: theme === "default" ? '#FFFFFF' : '#201F1F'
                }
            }
        }]
    };

    const openContent = () => {
        if (selectedFileIds.length > 0) {
            selectedFileIds.map((file) => { file.fileId && window.open(`https://app.bigtincan.com/file/${file.fileId}`); });
        }
    }

    //Tabbed view is disabled for now
    //const openContent = () => {
    //    setTabbedView(true);
    //}

    //Tabbed view is disabled for now
    //const onCloseTabbed = () => {
    //    updateSelectedFileIds([]);
    //    setTabbedView(false);
    //}

    React.useEffect(() => {
        if (teamEventCard && teamEventCard.attendees) {
            const attendees = teamEventCard.attendees.map(c => {
                return {
                    email: c.emailAddress.address,
                    name: c.emailAddress.name,
                    status: c.status.response,
                }
            });
            setAttendies(attendees);
        }
    }, [teamEventCard]);

    const onSuccess = () => {
        dispatch(updateMessage('Content successfully shared'));
    };

    const [showShareDialog, { toggle: toggleShareDialog, setTrue: hideDialogShare }] = useBoolean(true);
    const [showShareDialogMobile, { toggle: toggleShareDialogMobile }] = useBoolean(false);
    const [attendies, setAttendies] = React.useState([] as {
        email: string,
        name: string,
        status: string
    }[]);

    const [currentFiles, setCurrentFiles] = React.useState([] as HubFile[]);

    const onShareAll = () => {
        updateShareItems();
        if (isMobile) {
            toggleShareDialogMobile();
        }
        else {
            toggleShareDialog();
        }
    };

    const updateShareItems = () => {
        setCurrentFiles(([] as HubFile[]));
        let tempFiles = ([] as HubFile[]);
        for (var i = 0; i < selectedFileIds.length; i++) {
            if (selectedFileIds[i].file.shareStatus != 'blocked') {
                tempFiles.push(selectedFileIds[i].file);
            }
        }
        setCurrentFiles(tempFiles);
    };

    const renderMobile = () => {
        return (
            <>
                <Flex className={[styles.signOutHeader, styles["ms-teams-theme-" + theme]].join(' ')}>
                    <FlexItem push>
                        <Button className={styles.signOut} text size="medium" onClick={signOut} content="Sign out" />
                    </FlexItem>
                </Flex>
                <Flex className={[styles.rootMobile, styles["ms-teams-theme-" + theme]].join(' ')} column={true}>
                    <Flex className={styles.header}>
                        <Flex>
                            <Label className={styles.currentDate}>{selectedDate.toDateString()}</Label>
                        </Flex>
                        <Flex className={styles.leftRightControl} gap={'gap.small'}>
                            <IconButton iconProps={leftIcon} onClick={decreaseDate} />
                            <IconButton iconProps={rightIcon} onClick={increaseDate} />
                            <IconButton className={styles.calendarIcon} iconProps={calendarIcon} onClick={openCal} />
                            {showCalCallout &&
                                <Callout role="alertDialog"
                                    className={styles.calCallout}
                                    backgroundColor={(theme === 'dark' || theme === 'contrast') ? "#000000" : "#FFFFFF"}
                                    gapSpace={0}
                                    target={`.${styles.calendarIcon}`}
                                    onDismiss={hideCal}>

                                    <CalendarInline theme={theme} goToDate={navDay} onSelectedDateChanged={selectedDateChanged} dateRangeType={0} autoNavigateOnSelection={true} showGoToToday={false} showNavigateButtons={true} isMonthPickerVisible={false} />
                                </Callout>}
                        </Flex>
                    </Flex>

                    {isEventLoder && <div className={styles.loader}><Loader /></div>}

                    {!showShareDialogMobile && !openAddContent && !isMeetingClicked && <>
                        <Flex column={true} className={styles.list}>
                            {teamEvents === null || (teamEvents != null && teamEvents.length === 0) && <>
                                <Flex className={styles.noMeetingsContainer}>
                                    <Label className={styles.lbl}>There are no meetings scheduled</Label>
                                </Flex></>
                            }
                            {teamEvents && teamEvents !== null && teamEvents.map((item) => {
                                return <div key={item.changeKey} onClick={() => { onMeetingClick(item) }}><Flex.Item key={item.changeKey} >
                                    <MeetingCard meetingDuration={getMeetingDuration(item.start.dateTime, item.end.dateTime)} isSelected={item.isSelected && selectedCard == item.id} isAppAdded={item.isAppAdded} fileCount={item.fileCount} meetingTitle={item.subject} imageInitials={extractInitials(item.organizer.emailAddress.name)} persona={item.organizer.emailAddress.name || 'NA'} duration={getLocalTime(item.start.dateTime) + ' - ' + getLocalTime(item.end.dateTime)} key={item.id} />
                                </Flex.Item></div>
                            })}
                        </Flex>
                        <Flex className={styles.calenderBtnContainer}>
                            <PrimaryButton className={styles.btn} onClick={onCalendarClick}>Schedule a meeting in Calendar</PrimaryButton>
                        </Flex></>
                    }

                    {!showShareDialogMobile && !openAddContent && isMeetingClicked && !isEventLoder && chatId && chatId != "" &&
                        <Flex className={styles.meetingContentContainer} column={true}>
                            <Flex>
                                <Flex className={styles.meetingMetaContainer}>
                                    <Label className={styles.titleContainer}>{subject}</Label>
                                    <Label className={styles.scheduleInfo}>{startTime}</Label>
                                    <Flex className={styles.personaContainer} gap='gap.small'>
                                        {teamEventCard && teamEventCard.attendees && teamEventCard.attendees.length > 0 && teamEventCard.attendees.slice(0, 7).map((atten) => {
                                            return <TooltipHost content={atten.emailAddress.name}> <Persona
                                                key={atten.emailAddress.name}
                                                imageInitials={extractInitials(atten.emailAddress.name)}
                                                size={PersonaSize.size32}
                                                presence={PersonaPresence.none}
                                                hidePersonaDetails={true}
                                            /></TooltipHost>
                                        })}
                                        {teamEventCard && teamEventCard.attendees && teamEventCard.attendees.length > 7 &&
                                            <TooltipHost content={calloutExtraName.join()}><Persona
                                                onMouseEnter={(e) => { onHoverExtra(e.currentTarget, teamEventCard.attendees) }}
                                                key={'123'}
                                                imageInitials={'+' + (teamEventCard.attendees.length - 7).toString()}
                                                size={PersonaSize.size32}
                                                presence={PersonaPresence.none}
                                                hidePersonaDetails={true}
                                            /></TooltipHost>
                                        }
                                    </Flex>
                                </Flex>
                                {isAppAdded && currentMeeting && currentMeeting.meetingContents.length > 0 &&
                                    <Flex className={styles.meetingSearchContainer}>
                                        <IconButton className={styles.searchInvoker} iconProps={addIcon} onClick={() => setOpenAddContent(true)} />
                                    </Flex>}
                            </Flex>
                            <Flex className={styles.seperator}></Flex>

                            {isAppAdded && currentMeeting && currentMeeting.meetingContents.length > 0 &&
                                <div style={{ height: '100%' }}>
                                    <Stack className={styles.list}>
                                        {isLoder && <div className={styles.loader}><Loader /></div>}
                                        {currentMeeting && currentMeeting.meetingContents && currentMeeting.meetingContents.map((item) => {
                                            return <Stack.Item key={item.fileId}>
                                                <MyMeetingFileItem fileItem={item} onItemClick={onFileItemDelete} onCheckedItemChange={onItemCheckedChanged} key={item.id} id={item.fileId} />
                                            </Stack.Item>
                                        })}
                                    </Stack>
                                    <Flex className={styles.btnSeperator}></Flex>
                                    <Flex className={styles.btnContent}>
                                        <TooltipHost content={'Join Meeting'}><IconButton className={styles.btnJoin} iconProps={joinIcon} onClick={onJoinClick} /></TooltipHost>
                                        <TooltipHost content={'Edit Meeting'}><IconButton className={styles.btnEdit} iconProps={editIcon} onClick={onEditClick} /></TooltipHost>
                                        <TooltipHost content={'Open File'}><IconButton className={styles.btnOpen} iconProps={fileIcon} onClick={openContent} disabled={selectedFileIds.length === 0} /></TooltipHost>
                                        <TooltipHost content={'Share Content'}><IconButton className={styles.btnShare} iconProps={shareIcon} onClick={onShareAll} disabled={selectedFileIds.length === 0} /></TooltipHost>
                                        <TooltipHost content={'Delete Content'}> <IconButton className={styles.btnDelete} iconProps={deleteIcon} onClick={() => { toggleHideDialog(); toggleHideDelete(); }} disabled={selectedFileIds.length === 0} /></TooltipHost>
                                    </Flex>
                                </div>}

                            {isAppAdded && currentMeeting && currentMeeting.meetingContents.length === 0 && <div style={{ width: '100%', height: '100%' }}>
                                <Stack className={styles.noContentContainer}>
                                    <figure>
                                        <img src={defaultImage} className={styles.img} />
                                        <Label className={styles.caption}>There is no content added to the meeting.</Label>
                                    </figure>
                                    <PrimaryButton className={styles.addContent} iconProps={addIcon} onClick={() => setOpenAddContent(true)} >Add Content</PrimaryButton>
                                </Stack></div>}

                            {!isAppAdded && <div style={{ width: '100%', height: '100%' }}><Stack className={styles.noContentContainer}>
                                <figure>
                                    <img src={defaultImage} className={styles.img} />
                                    <Label className={styles.caption}>There is no content added to the meeting.</Label>
                                </figure>
                                <PrimaryButton className={styles.addContent} iconProps={addIcon} onClick={() => setOpenAddContent(true)} >Add Content</PrimaryButton>
                            </Stack></div>}
                        </Flex>
                    }
                    {!showShareDialogMobile && openAddContent &&
                        <Flex column={true}>
                            <Flex>
                                <SearchContentInMeeting renderBookmarks={false} onSelectionChange={(data) => updateSelectedSearchFile(data)} />
                            </Flex>
                            <Flex className={styles.btnSearchContent} gap={'gap.small'}>
                                <DefaultButton className={styles.btnCancel} onClick={() => setOpenAddContent(false)}>Cancel</DefaultButton>
                                <PrimaryButton className={styles.btnAdd} disabled={selectedSearchFiles.length === 0} onClick={addSelectedFileToMeeting}>Add Files</PrimaryButton>
                            </Flex>
                        </Flex>}
                    <Dialog hidden={hideDialog}
                        onDismiss={toggleHideDialog}
                        dialogContentProps={dialogContentProps}
                        modalProps={modalProps}
                        styles={dialogStyles}>
                        <DialogFooter>
                            <DefaultButton style={{ color: theme === "default" ? '#000000' : '#FFFFFF', background: theme === "default" ? '#FFFFFF' : '#000000', padding: '10px 12px' }} onClick={onCancelClick} text="Cancel" />
                            <PrimaryButton style={{ color: ' #FFFFFF', background: '#C4314B', padding: '10px 12px', border: '1px solid transparent' }} onClick={onRemoveFile} text="Remove" />
                        </DialogFooter>
                    </Dialog>
                    {showShareDialogMobile && <HubShareDialog isPersonal={true} isMobile={true} subject={teamEventCard ? teamEventCard.subject : ''} onSuccess={onSuccess} attendee={attendies} files={currentFiles} onDismiss={() => { updateSelectedFileIds([]); toggleShareDialogMobile(); }} isOpen={showShareDialogMobile} />}
                </Flex>
            </>
        )
    }

    const renderDesktop = () => {
        return (
            <>
                <Flex className={[styles.signOutHeader, styles["ms-teams-theme-" + theme]].join(' ')}>
                    <FlexItem push>
                        <Button className={styles.signOut} text size="medium" onClick={signOut} content="Sign out" />
                    </FlexItem>
                </Flex>
                <Flex className={[styles.root, styles["ms-teams-theme-" + theme]].join(' ')}>
                    <Stack className={styles.calendarContainer} id='calendarContainer'>
                        <CalendarInline theme={theme} goToDate={navDay} onSelectedDateChanged={selectedDateChanged} dateRangeType={0} autoNavigateOnSelection={true} showGoToToday={false} showNavigateButtons={true} isMonthPickerVisible={false} />
                    </Stack>
                    <Stack className={styles.meetingsContainer} verticalFill={true}>
                        <Flex className={styles.header}>
                            <Flex>
                                <Label className={styles.currentDate}>{selectedDate.toDateString()}</Label>
                            </Flex>
                            <Flex className={styles.leftRightControl} gap={'gap.small'}>
                                <IconButton iconProps={leftIcon} onClick={decreaseDate} />
                                <Label className={styles.today} onClick={goToToday}>Today</Label>
                                <IconButton iconProps={rightIcon} onClick={increaseDate} />
                                <IconButton className={styles.calendarIcon} iconProps={calendarIcon} onClick={openCal} />
                            </Flex>
                        </Flex>
                        {showCalCallout &&
                            <Callout role="alertDialog"
                                className={styles.calCallout}
                                gapSpace={0}
                                target={`.${styles.calendarIcon}`}
                                onDismiss={hideCal}>
                                <CalendarInline goToDate={navDay} onSelectedDateChanged={selectedDateChanged} dateRangeType={0} autoNavigateOnSelection={true} showGoToToday={false} showNavigateButtons={true} isMonthPickerVisible={false} />
                            </Callout>}

                        <Flex column={true} className={styles.list}>
                            {teamEvents === null || (teamEvents != null && teamEvents.length === 0) && <div>
                                <Flex className={styles.noMeetingsContainer}>
                                    <Label className={styles.lbl}>There are no meetings scheduled</Label>
                                </Flex></div>
                            }
                            {teamEvents && teamEvents !== null && teamEvents.map((item) => {
                                return <div key={item.changeKey} onClick={() => { onMeetingClick(item) }}><Flex.Item key={item.changeKey} >
                                    <MeetingCard meetingDuration={getMeetingDuration(item.start.dateTime, item.end.dateTime)} isSelected={item.isSelected && selectedCard == item.id} isAppAdded={item.isAppAdded} fileCount={item.fileCount} meetingTitle={item.subject} imageInitials={extractInitials(item.organizer.emailAddress.name)} persona={item.organizer.emailAddress.name || 'NA'} duration={getLocalTime(item.start.dateTime) + ' - ' + getLocalTime(item.end.dateTime)} key={item.id} />
                                </Flex.Item></div>
                            })}

                        </Flex>
                        <Flex className={styles.calenderBtnContainer}>
                            <PrimaryButton className={styles.btn} onClick={onCalendarClick}>Schedule a meeting in Calendar</PrimaryButton>
                        </Flex>
                    </Stack>

                    {isEventLoder && <div className={styles.loader}><Loader /></div>}

                    <DialogNorth id="fileSearchDialog" className={styles.searchDialog}
                        open={openAddContent}
                        content={<SearchContent onSelectionChange={(data) => updateSelectedSearchFile(data)} />}
                        footer={{
                            children: (_Component: any, props: { [x: string]: any; styles: any; }) => {
                                const { styles, ...rest } = props
                                return (
                                    <Flex styles={styles}>
                                        <Flex.Item push>
                                            <Button onClick={() => setOpenAddContent(false)} content='Cancel' />
                                        </Flex.Item>
                                        <Button disabled={selectedSearchFiles.length === 0} onClick={addSelectedFileToMeeting} style={{ marginLeft: 5 }} content='Add Files' primary />
                                    </Flex>
                                )
                            },
                        }}
                    />

                    {!isEventLoder && chatId && chatId != "" &&
                        <Flex className={styles.meetingContentContainer}>
                            <Flex>
                                <Flex className={styles.meetingMetaContainer}>
                                    <Label className={styles.titleContainer}>{subject}</Label>
                                    <Label className={styles.scheduleInfo}>{startTime}</Label>
                                    <Flex className={styles.personaContainer} gap='gap.small'>
                                        {teamEventCard && teamEventCard.attendees && teamEventCard.attendees.length > 0 && teamEventCard.attendees.slice(0, 7).map((atten) => {
                                            return <TooltipHost content={atten.emailAddress.name}> <Persona
                                                key={atten.emailAddress.name}
                                                imageInitials={extractInitials(atten.emailAddress.name)}
                                                size={PersonaSize.size32}
                                                presence={PersonaPresence.none}
                                                hidePersonaDetails={true}
                                            /></TooltipHost>
                                        })}
                                        {teamEventCard && teamEventCard.attendees && teamEventCard.attendees.length > 7 &&
                                            <TooltipHost content={calloutExtraName.join()}><Persona
                                                onMouseEnter={(e) => { onHoverExtra(e.currentTarget, teamEventCard.attendees) }}
                                                key={'123'}
                                                imageInitials={'+' + (teamEventCard.attendees.length - 7).toString()}
                                                size={PersonaSize.size32}
                                                presence={PersonaPresence.none}
                                                hidePersonaDetails={true}
                                            /></TooltipHost>
                                        }
                                    </Flex>
                                </Flex>
                                {isAppAdded && currentMeeting && currentMeeting.meetingContents.length > 0 &&
                                    <Flex className={styles.meetingSearchContainer}>
                                        <IconButton className={styles.searchInvoker} iconProps={addIcon} onClick={() => setOpenAddContent(true)} />
                                    </Flex>}
                            </Flex>
                            <Flex className={styles.seperator}></Flex>

                            {isAppAdded && currentMeeting && currentMeeting.meetingContents.length > 0 && <div><Stack className={styles.list}>
                                {isLoder && <div className={styles.loader}><Loader /></div>}
                                {currentMeeting && currentMeeting.meetingContents && currentMeeting.meetingContents.map((item) => {
                                    return <Stack.Item key={item.fileId}>
                                        <MyMeetingFileItem fileItem={item} onItemClick={onFileItemDelete} onCheckedItemChange={onItemCheckedChanged} key={item.id} id={item.fileId} />
                                    </Stack.Item>
                                })}
                            </Stack>
                                <Flex className={styles.btnSeperator}></Flex>
                                <Stack className={styles.btnContent}>
                                    <TooltipHost content={'Join Meeting'}><IconButton className={styles.btnJoin} iconProps={joinIcon} onClick={onJoinClick} /></TooltipHost>
                                    <TooltipHost content={'Edit Meeting'}><IconButton className={styles.btnEdit} iconProps={editIcon} onClick={onEditClick} /></TooltipHost>
                                    <TooltipHost content={'Open File'}><IconButton className={styles.btnOpen} iconProps={fileIcon} onClick={openContent} disabled={selectedFileIds.length === 0} /></TooltipHost>
                                    <TooltipHost content={'Share Content'}><IconButton className={styles.btnShare} iconProps={shareIcon} onClick={onShareAll} disabled={selectedFileIds.length === 0} /></TooltipHost>
                                    <TooltipHost content={'Delete Content'}> <IconButton className={styles.btnDelete} iconProps={deleteIcon} onClick={() => { toggleHideDialog(); toggleHideDelete(); }} disabled={selectedFileIds.length === 0} /></TooltipHost>
                                </Stack>
                            </div>}

                            {isAppAdded && currentMeeting && currentMeeting.meetingContents.length === 0 && <div style={{ width: '100%', height: '100%' }}><Stack className={styles.noContentContainer}>
                                <figure>
                                    <img src={defaultImage} className={styles.img} />
                                    <Label className={styles.caption}>There is no content added to the meeting.</Label>
                                </figure>
                                <PrimaryButton className={styles.addContent} iconProps={addIcon} onClick={() => setOpenAddContent(true)} >Add Content</PrimaryButton>
                            </Stack></div>}

                            {!isAppAdded && <div style={{ width: '100%', height: '100%' }}><Stack className={styles.noContentContainer}>
                                <figure>
                                    <img src={defaultImage} className={styles.img} />
                                    <Label className={styles.caption}>There is no content added to the meeting.</Label>
                                </figure>
                                <PrimaryButton className={styles.addContent} iconProps={addIcon} onClick={() => setOpenAddContent(true)} >Add Content</PrimaryButton>
                            </Stack></div>}
                        </Flex>
                    }
                    <Dialog hidden={hideDialog}
                        onDismiss={toggleHideDialog}
                        dialogContentProps={dialogContentProps}
                        modalProps={modalProps}
                        styles={dialogStyles}>
                        <DialogFooter>
                            <DefaultButton style={{ color: theme === "default" ? '#000000' : '#FFFFFF', background: theme === "default" ? '#FFFFFF' : '#000000', padding: '10px 12px' }} onClick={onCancelClick} text="Cancel" />
                            <PrimaryButton style={{ color: ' #FFFFFF', background: '#C4314B', padding: '10px 12px', border: '1px solid transparent' }} onClick={onRemoveFile} text="Remove" />
                        </DialogFooter>
                    </Dialog>
                    <HubShareDialog subject={teamEventCard ? teamEventCard.subject : ''} onSuccess={onSuccess} attendee={attendies} files={currentFiles} onDismiss={hideDialogShare} isOpen={showShareDialog} />
                </Flex>
            </>
        )
    }

    //Tabbed view is disabled for now
    //const renderTabbedView = () => {
    //    return (
    //        <>
    //            <ShareTabbedView files={selectedFileIds} onDismiss={onCloseTabbed}/>
    //        </>
    //    );
    //}

    return (
        <>
            {!isMobile && renderDesktop()}
            {isMobile && renderMobile()}
        </>
    );

    //Tabbed view is disabled for now
    //return (
    //    <>
    //        {isTabbedView && renderTabbedView()}
    //        {!isTabbedView && !isMobile && renderDesktop()}
    //        {!isTabbedView && isMobile && renderMobile()}
    //    </>
    //);

};

export default connect()(MyMeetings);
